module.exports = __webpack_public_path__ + "static/Avenir-Heavy-179a19323468a59eba775c9bb229c222.woff2";